"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lab = require("@material-ui/lab");
var _core = require("@material-ui/core");
var _SttText = _interopRequireDefault(require("../SttTypography/SttText"));
var _SttPaper = _interopRequireDefault(require("../SttPaper"));
var _reactResponsive = require("react-responsive");
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _aprovar = require("../imagens/icones-indicacao/aprovar.svg");
var _autorizar = require("../imagens/icones-indicacao/autorizar.svg");
var _cancelar = require("../imagens/icones-indicacao/cancelar.svg");
var _devolver = require("../imagens/icones-indicacao/devolver.svg");
var _encaminhado = require("../imagens/icones-indicacao/encaminhado.svg");
var _invalidar = require("../imagens/icones-indicacao/invalidar.svg");
var _encaminharautorizador = require("../imagens/icones-indicacao/encaminharautorizador.svg");
var _alterar = require("../imagens/icones-indicacao/alterar.svg");
var _gerarnumero = require("../imagens/icones-indicacao/gerarnumero.svg");
var _trocarfaixa = require("../imagens/icones-indicacao/trocarfaixa.svg");
var _gasespera = require("../imagens/icones-indicacao/gasespera.svg");
var _gasestacionario = require("../imagens/icones-indicacao/gasestacionario.svg");
var _gasportatil = require("../imagens/icones-indicacao/gasportatil.svg");
var _aprovar2 = require("../imagens/icones-tfd-passagens/aprovar.svg");
var _arquivar = require("../imagens/icones-tfd-passagens/arquivar.svg");
var _cancelar2 = require("../imagens/icones-tfd-passagens/cancelar.svg");
var _devolver2 = require("../imagens/icones-tfd-passagens/devolver.svg");
var _encaminhar = require("../imagens/icones-tfd-passagens/encaminhar.svg");
var _criacao = require("../imagens/icones-tfd-passagens/criacao.svg");
var _comprovante = require("../imagens/icones-tfd-passagens/comprovante.svg");
var _fatura = require("../imagens/icones-tfd-passagens/fatura.svg");
var _motorista = require("../imagens/icones-tfd-passagens/motorista.svg");
var _suspensao = require("../imagens/icones-tfd-passagens/suspensao.svg");
var _voltaprocesso = require("../imagens/icones-tfd-passagens/voltaprocesso.svg");
var _reabrir = require("../imagens/icones-tfd-passagens/reabrir.svg");
var _removerdossie = require("../imagens/icones-tfd-passagens/removerdossie.svg");
var _alterardossie = require("../imagens/icones-tfd-passagens/alterardossie.svg");
var _inclusaodossie = require("../imagens/icones-tfd-passagens/inclusaodossie.svg");
var _sinalizar = require("../imagens/icones-indicacao/sinalizar.svg");
var _arquivar2 = require("../imagens/icones-indicacao/arquivar.svg");
var _informar = require("../imagens/icones-indicacao/informar.svg");
var _regular = require("../imagens/icones-indicacao/regular.svg");
var _informarnumero = require("../imagens/icones-indicacao/informarnumero.svg");
var _aguardar = require("../imagens/icones-indicacao/aguardar.svg");
var _confirmar = require("../imagens/icones-indicacao/confirmar.svg");
var _inativar = require("../imagens/icones-indicacao/inativar.svg");
var _anexar = require("../imagens/icones-indicacao/anexar.svg");
var _comprovarservico = require("../imagens/icones-indicacao/comprovarservico.svg");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    paper: _defineProperty({
      padding: "12px 16px",
      display: "inline-block",
      minWidth: 220
    }, theme.breakpoints.down('sm'), {
      padding: "8px 8px",
      minWidth: 120
    }),
    timelineDot: _defineProperty({
      color: (0, _colorManipulator.alpha)(theme.palette.primary.main, 0.3)
    }, theme.breakpoints.down('sm'), {
      width: 28,
      height: 28,
      minWidth: 28,
      minHeight: 28
    }),
    responsavel: _defineProperty({
      borderRadius: 4,
      padding: "4px 12px",
      fontWeight: 700,
      display: "inline-block",
      fontSize: 13,
      marginBottom: 8
    }, theme.breakpoints.down('sm'), {
      padding: "2px 6px",
      fontSize: 11,
      marginBottom: 4,
      display: 'flex',
      justifyContent: 'flex-start',
      width: "fit-content",
      textAlign: 'left'
    }),
    data: _defineProperty({
      fontSize: theme.typography.fontSize,
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      marginTop: 10
    }, theme.breakpoints.down('sm'), {
      fontSize: 11,
      marginTop: 4
    }),
    conteudo: _defineProperty({}, theme.breakpoints.down('sm'), {
      fontSize: 12,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      textAlign: 'left'
    })
  };
});
var icones = [{
  identificador: "ENCAMINHAMENTO",
  icone: _encaminhado.ReactComponent
}, {
  identificador: "INVALIDACAO",
  icone: _invalidar.ReactComponent
}, {
  identificador: "INDEFERIMENTO",
  icone: _invalidar.ReactComponent
}, {
  identificador: "AUTORIZACAO",
  icone: _autorizar.ReactComponent
}, {
  identificador: "ALTERACAO",
  icone: _alterar.ReactComponent
}, {
  identificador: "TROCA_FAIXA",
  icone: _trocarfaixa.ReactComponent
}, {
  identificador: "GERACAO_NUMERO_APAC",
  icone: _gerarnumero.ReactComponent
}, {
  identificador: "APROVACAO",
  icone: _aprovar.ReactComponent
}, {
  identificador: "CANCELAMENTO",
  icone: _cancelar.ReactComponent
}, {
  identificador: "DEVOLUCAO",
  icone: _devolver.ReactComponent
}, {
  identificador: "ENCAMINHAMENTO_AUTORIZADOR",
  icone: _encaminharautorizador.ReactComponent
}, {
  identificador: "GERACAO_GAS_PORTATIL",
  icone: _gasportatil.ReactComponent
}, {
  identificador: "GERACAO_GAS_ESTACIONARIO",
  icone: _gasestacionario.ReactComponent
}, {
  identificador: "GERACAO_GAS_LISTA_ESPERA_ESTACIONARIO",
  icone: _gasespera.ReactComponent
}, {
  identificador: "GERACAO_GAS_LISTA_ESPERA_PORTATIL",
  icone: _gasespera.ReactComponent
}, {
  identificador: 'GERACAO_GAS_MUNICIPIO_PLENO',
  icone: _gasestacionario.ReactComponent
}, {
  identificador: "APROVACAO_TFD_PASSAGEM",
  icone: _aprovar2.ReactComponent
}, {
  identificador: "ARQUIVAMENTO_TFD_PASSAGEM",
  icone: _arquivar.ReactComponent
}, {
  identificador: "CANCELAMENTO_TFD_PASSAGEM",
  icone: _cancelar2.ReactComponent
}, {
  identificador: "DEVOLUCAO_TFD_PASSAGEM",
  icone: _devolver2.ReactComponent
}, {
  identificador: "ENCAMINHAMENTO_TFD_PASSAGEM",
  icone: _encaminhar.ReactComponent
}, {
  identificador: "CRIACAO_TFD_PASSAGENS",
  icone: _criacao.ReactComponent
}, {
  identificador: "COMPROVANTE_TFD_PASSAGEM",
  icone: _comprovante.ReactComponent
}, {
  identificador: "FATURA_TFD_PASSAGEM",
  icone: _fatura.ReactComponent
}, {
  identificador: "MOTORISTA_TFD_PASSAGEM",
  icone: _motorista.ReactComponent
}, {
  identificador: "SUSPENSAO_TFD_PASSAGEM",
  icone: _suspensao.ReactComponent
}, {
  identificador: "VOLTA_PROCESSO_TFD_PASSAGEM",
  icone: _voltaprocesso.ReactComponent
}, {
  identificador: "REABERTURA_TFD_PASSAGEM",
  icone: _reabrir.ReactComponent
}, {
  identificador: "REMOVER_DOSSIE_TFD_PASSAGEM",
  icone: _removerdossie.ReactComponent
}, {
  identificador: "ALTERAR_DOSSIE_TFD_PASSAGEM",
  icone: _alterardossie.ReactComponent
}, {
  indentificador: "INCLUSAO_DOSSIE_TFD_PASSAGEM",
  icone: _inclusaodossie.ReactComponent
}, {
  identificador: "NEGACAO",
  icone: _cancelar.ReactComponent
}, {
  identificador: "ENCAMINHAMENTO_TFD_ESTADUAL",
  icone: _encaminhado.ReactComponent
}, {
  identificador: "AGUARDANDO_AGENDAMENTO_CNRAC",
  icone: _aguardar.ReactComponent
}, {
  identificador: "AGUARDANDO_AGENDAMENTO",
  icone: _aguardar.ReactComponent
}, {
  identificador: "AGUARDANDO_PRESTADOR",
  icone: _aguardar.ReactComponent
}, {
  identificador: "INFORMAR_NUMERO_CNRAC",
  icone: _informarnumero.ReactComponent
}, {
  identificador: "REGULAR",
  icone: _regular.ReactComponent
}, {
  identificador: "INFORMAR_PROCEDIMENTO_SOLICITADO",
  icone: _informar.ReactComponent
}, {
  identificador: "CONFIRMAR_AGENDAMENTO",
  icone: _confirmar.ReactComponent
}, {
  identificador: "ARQUIVAR_PROCESSO",
  icone: _arquivar2.ReactComponent
}, {
  identificador: 'SINALIZAR_PENDENCIA',
  icone: _sinalizar.ReactComponent
}, {
  identificador: "INATIVAR_COMPROVANTE_COMPARECIMENTO",
  icone: _inativar.ReactComponent
}, {
  identificador: 'ANEXAR_COMPROVANTE_COMPARECIMENTO',
  icone: _anexar.ReactComponent
}, {
  identificador: "COMPROVACAO_SERVICO",
  icone: _comprovarservico.ReactComponent
}, {
  identificador: "DEFERIMENTO_COMPROVACAO_SERVICO",
  icone: _comprovarservico.ReactComponent
}, {
  identificador: "DEVOLUCAO_COMPROVACAO_SERVICO",
  icone: _devolver.ReactComponent
}, {
  identificador: "FINALIZACAO_COMPROVACAO_SERVICO",
  icone: _arquivar2.ReactComponent
}, {
  identificador: "CRIACAO",
  icone: _alterar.ReactComponent
}];
var TimelineProcesso = function TimelineProcesso(_ref) {
  var props = _ref.props;
  var dados = props.dados,
    config = props.config;
  var classes = useStyles();
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: 841
  });
  return /*#__PURE__*/_react["default"].createElement(_lab.Timeline, {
    align: isMobile ? 'right' : 'alternate'
  }, dados.map(function (item, idx) {
    var _icones$find;
    var DotIcone = config[item.tipo].icone || ((_icones$find = icones.find(function (icone) {
      return icone.identificador === item.tipo;
    })) === null || _icones$find === void 0 ? void 0 : _icones$find.icone) || null;
    var CorConfig = config[item.tipo];
    var IconeInformativo = config[item.tipo].iconeInformativo || null;
    return /*#__PURE__*/_react["default"].createElement(_lab.TimelineItem, {
      key: idx
    }, /*#__PURE__*/_react["default"].createElement(_lab.TimelineOppositeContent, {
      className: classes.data
    }, item.data_hora_formatada), /*#__PURE__*/_react["default"].createElement(_lab.TimelineSeparator, null, /*#__PURE__*/_react["default"].createElement(_lab.TimelineDot, {
      style: {
        background: CorConfig.cor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      className: classes.timelineDot
    }, DotIcone ? /*#__PURE__*/_react["default"].createElement(DotIcone, {
      style: {
        width: 24,
        height: 24,
        color: '#865829'
      }
    }) : /*#__PURE__*/_react["default"].createElement(IconeEncaminharOxi, {
      style: {
        width: 24,
        height: 24
      }
    })), idx < dados.length - 1 && /*#__PURE__*/_react["default"].createElement(_lab.TimelineConnector, null)), /*#__PURE__*/_react["default"].createElement(_lab.TimelineContent, null, /*#__PURE__*/_react["default"].createElement(_SttPaper["default"], {
      elevation: 3,
      className: classes.paper
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
      variant: "h6",
      component: "h1",
      className: classes.responsavel,
      style: {
        background: CorConfig.responsavelBg,
        color: CorConfig.responsavelColor
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        gap: "10px"
      }
    }, item.nome_funcionario, IconeInformativo ? IconeInformativo({
      dados: dados,
      index: idx
    }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)))), /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
      className: classes.conteudo
    }, /*#__PURE__*/_react["default"].createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.conteudo
      }
    })))));
  }));
};
var _default = TimelineProcesso;
exports["default"] = _default;